import styled from 'styled-components';
import { MagnifyingGlass } from '@rainbow-modules/icons';
import Contacts from 'components/icons/contacts';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Title = styled.h3`
    font-size: 16px;
    color: ${(props) => props.theme.rainbow.palette.text.main};
    font-family: 'Lato Bold', Arial, Helvetica, sans-serif;
`;

export const Description = styled.p`
    font-size: 14px;
    color: ${(props) => props.theme.rainbow.palette.text.label};
    margin-top: 4px;
`;

export const Icon = styled(MagnifyingGlass)`
    width: 48px;
    height: 48px;
    color: ${(props) => props.theme.rainbow.palette.border.divider};
    margin-bottom: 12px;
`;

export const Bold = styled.span`
    font-family: 'Lato Bold', Arial, Helvetica, sans-serif;
`;

export const ContactsIcon = styled(Contacts)`
    margin-bottom: 12px;
    height: 48px;
    width: 48px;
    flex-shrink: 0;
`;

export const EmptyMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
